/**
 * Returns a unique API key name by appending a numeric suffix when needed.
 * Uses strict (case-sensitive) comparison and preserves the full input string.
 *
 * @example
 * getUniqueApiKeyName('MyKey', ['MyKey'])
 * // => 'MyKey_2'
 *
 * @example
 * getUniqueApiKeyName('MyKey', ['MyKey', 'MyKey_2'])
 * // => 'MyKey_3'
 *
 * @example
 * getUniqueApiKeyName('MyKey_2', ['MyKey_2'])
 * // => 'MyKey_2_2'
 *
 * @example
 * getUniqueApiKeyName('  MyKey  ', [])
 * // => 'MyKey'
 */
export const getUniqueApiKeyName = (name: string, existingNames: string[]) => {
  const trimmed = name.trim()
  if (!trimmed) return trimmed

  const existing = new Set(existingNames)
  if (!existing.has(trimmed)) return trimmed

  let suffix = 2
  let candidate = `${trimmed}_${String(suffix)}`
  while (existing.has(candidate)) {
    suffix += 1
    candidate = `${trimmed}_${String(suffix)}`
  }
  return candidate
}
